import React from 'react';
import styled from 'styled-components';
import { RectShape } from 'react-placeholder/lib/placeholders';
import "react-placeholder/lib/reactPlaceholder.css";
import { device } from 'vqp-common';

import useFetch from '../../utils/useFetch'
import { fetchProductsRanking, fetchClientsRanking } from '../../redux/actions/dashboard'

import { ProductsRanking, ClientsRanking } from './'

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 15px;
    margin: 15px;

    @media ${device.desktop} {
        grid-template-columns: 1fr 1fr;
    }
`


export const RankingsPanel = ({filterDates}) => {

    const productsRanking = useFetch(fetchProductsRanking, filterDates)
    const clientsRanking = useFetch(fetchClientsRanking, filterDates)

    const drawLoading = () => (
        <RectShape color='#E0E0E0' showLoadingAnimation={true} style={{ width: '100%', height: 300 }} />
    )

    const drawProductsRanking = () => {
        if (productsRanking.loading) return drawLoading()
        if (productsRanking.response) return (
            <ProductsRanking products={productsRanking.response} />
        )
        return null;
    }

    const drawClientsRanking = () => {
        if (clientsRanking.loading) return drawLoading()
        if (clientsRanking.response) return (
            <ClientsRanking clients={clientsRanking.response} />
        )
        return null;
    }
    
    return (
        <Grid>
            {drawProductsRanking()}
            {drawClientsRanking()}
        </Grid>
    )
}